import { Outlet, useOutletContext } from 'react-router-dom'
import { PageHeadersCtx } from '@/src/hooks/use-page-headers/usePageHeaders'
import { useTrackSection } from '@/src/analytics/hooks/use-track-section/useTrackSection'

const Layout = () => {
  const { setTitle, setSubTitle } = useOutletContext<PageHeadersCtx>()
  useTrackSection()
  return <Outlet context={{ setTitle, setSubTitle }} />
}

export default Layout
